// extracted by mini-css-extract-plugin
export default {"sr-only":"Radio__sr-only--CifhE Accessibility__sr-only--fRyoV","default":"Radio__default--rKLzt"};